export default "/b554e21ed8a659b822597c92967d1f4c2aa51bb5/2cb37da391587709fd85749e116baa74.svg";